/**
 * What the Help button is allowed to attach (issue #175).
 *
 * A pathname, a coarse device class, the window size, the app version, and a
 * support code already on the screen. Not the query string, not the page
 * text, and not anything from a roster.
 */

export const WEB_APP_VERSION = '0.0.0';

export type HelpDevice = 'phone' | 'tablet' | 'desktop';

export function deviceClass(width: number): HelpDevice {
  if (width < 640) return 'phone';
  if (width < 1024) return 'tablet';
  return 'desktop';
}

export function viewportLabel(width: number, height: number): string {
  const w = Math.round(width);
  const h = Math.round(height);
  if (!Number.isFinite(w) || !Number.isFinite(h) || w < 10 || h < 10 || w > 20_000 || h > 20_000) {
    return 'unknown';
  }
  return `${String(w)}x${String(h)}`;
}

/** The last support line on the screen, and nothing else from that text. */
export function supportCodeOnScreen(text: string): string | undefined {
  const matches = [...text.matchAll(/Quote this code to support: ([A-Z0-9-]{4,12})(?=\.|\s|$)/g)];
  return matches.at(-1)?.[1];
}
